export enum PowerDialerRoutes {
  root = 'power-dialer',
  view = 'view',
}
